import { get, post, put, Delete } from "../axios";

// 新闻资讯-列表
export const newsInfoList = (params) => get("/web/news/info/list", params);

// 新闻资讯-新增
export const newsInfoAdd = (params) => post("/web/news/info/add", params);

// 新闻资讯-编辑
export const newsInfoUpdate = (params) => put("/web/news/info/update", params);

// 新闻资讯-删除
export const newsInfoDelete = (id) => Delete("/web/news/info/delete/" + id, "");

// 新闻资讯-详情
export const newsInfoview = (id) => get("/web/news/info/view/" + id, "");

// 新闻资讯-首页推荐-状态编辑
export const newsInfoHomeUpdate = (params) =>
  put("/web/news/info/home/update", params);

/**
 * 新闻资讯-上下架-状态更新
 * @param {Object} params - 包含 id 和 isPublish (1-上架, 2-下架)
 * @returns {Promise} API 请求 Promise
 */
export const newsInfoPublishUpdate = (params) =>
  put("/web/news/info/publish/update", params);

/**
 * 新闻资讯-是否公开-状态更新
 * @param {Object} params - 包含 id 和 isPublic (1-是, 2-否)
 * @returns {Promise} API 请求 Promise
 */
export const newsInfoPublicUpdate = (params) =>
  put("/web/news/info/public/update", params);

